<template>
  <!-- 全体を囲む -->
  <div class="content-wrapper">
    <div v-if="isReadyToDraw">
      <TheNotificationsArea :notifications="notifications" />

      <TemplateTicketStoreIndex
        :master-books-for-each-areas="masterBooksForEachAreas"
      />
    </div>

    <ItemDialogForIndexPage
      v-else
      :initial-open="true"
      title="読み込み中..."
      image-type="loader"
    />
  </div>
</template>

<script>
import { onMounted, computed, watchEffect, ref } from "vue";
import { useStore } from "vuex";

import TemplateTicketStoreIndex from "@/views/Templates/TicketStore/TemplateTicketStoreIndex";

import API from "@/API";

import masterBookSetsService from "@/services/masterBookSets";
import nativeHandlerService from "@/services/nativeHandler";

export default {
  components: {
    TemplateTicketStoreIndex: TemplateTicketStoreIndex,
  },
  setup() {
    const isReadyToDraw = ref(false);

    const store = useStore();
    const notifications = ref(null);

    onMounted(async () => {
      // 次のページでDivisionをいじりたいが、他のMasterbookを踏んだ後だとそれが登録されてしまうのでここでリセット
      if (process.env.NODE_ENV == "local") {
        store.commit("input/ticketing/resetStoreDivisions");
        // マスターブックの初期化
        store.commit("ticketing/setMasterBook", []);
        store.commit("ticketing/setMasterBookSet", null);
      }

      // index上部に表示する通知を取得
      try {
        notifications.value = (await API.getNotifications()).buy_tickets;
      } catch (err) {
        console.log("Error in getNotifications: ", err);
      }

      try {
        await API.getMasterBookSets();
      } catch (err) {
        console.log("Error in getMasterBookSets: ", err);
        nativeHandlerService.ncSendTicketingError(
          "TicketStoreIndex onMounted()",
          JSON.stringify(err)
        );
      }
    });

    const masterBookSets = computed(
      () => store.getters["ticketing/masterBookSets"]
    );
    const masterBooksForEachAreas = computed(() =>
      masterBookSetsService.forTicketStoreIndex(masterBookSets.value)
    );

    watchEffect(() => {
      if (Object.keys(masterBooksForEachAreas.value).length !== 0) {
        isReadyToDraw.value = true;
      }
    });

    return {
      isReadyToDraw,
      masterBooksForEachAreas,
      notifications,
    };
  },
};
</script>

<style scoped lang="scss">
.index {
  position: relative;
}
</style>
